import React, { useCallback, Fragment } from 'react';
import cl from 'classnames';

import { Translate } from '../Translate';
import { GADataType } from '../../types';

export interface CheckboxProps {
  checkboxWrapperClassName?: string;
  checked?: boolean;
  disabled?: boolean;
  error?: string | null;
  errorClassName?: string;
  i18nLabel?: string;
  id?: string;
  checkboxClassName?: string;
  label?: string;
  labelClassName?: string;
  name?: string;
  onChange?: (value: boolean) => void;
}

function Checkbox({
  checkboxClassName,
  checkboxWrapperClassName,
  checked = false,
  dataGa,
  disabled,
  error,
  errorClassName,
  i18nLabel,
  id,
  label,
  labelClassName,
  name,
  onChange
}: CheckboxProps & GADataType) {
  const handleCheck = useCallback(
    () => onChange && onChange(!checked),
    [checked, onChange]
  );

  const checkboxView = (
    <input
      checked={checked}
      className={cl(checkboxClassName || 'basic-checkbox')}
      data-ga={dataGa}
      disabled={disabled}
      id={id}
      name={name}
      onChange={disabled ? undefined : handleCheck}
      type="checkbox"
    />
  );

  if (checkboxWrapperClassName) {
    return (
      <Fragment>
        <div className={checkboxWrapperClassName}>
          {checkboxView}

          {i18nLabel || label ? (
            <label
              className={cl(
                labelClassName ||
                  'ml-2 block text-sm text-gray-900 dark:text-gray-100 truncate'
              )}
              onClick={disabled ? undefined : handleCheck}
            >
              {i18nLabel ? <Translate id={i18nLabel} /> : label}
            </label>
          ) : null}
        </div>

        {error && (
          <p className={cl(errorClassName || 'mt-2 text-sm text-red-600')}>
            {/^forms\.errors+/.test(error) ? <Translate id={error} /> : error}
          </p>
        )}
      </Fragment>
    );
  }

  return checkboxView;
}

export default Checkbox;
